import React, { FC } from 'react';
import { Button, Input, Select } from '@ui';
import { QmUsersRolesListType, QmUserWithRoleType } from '@app/interfaces/qm-users.type';
import { OptionItem } from '@app/components/ui/select/select.type';
import { useForm } from 'react-hook-form';
import useTranslation from '@app/hooks/use-translation';
import { useSetQmUserRoleMutation } from '@app/store/api/qm-module/qm-users/qm-users.api';
import {
  formBaseButtonBlockStyles,
  formBaseContainerStyles,
  formFieldBaseStylesModal650,
  formFieldNameBaseStyles,
} from '@app/styles/base-styles';

const rolesList: QmUsersRolesListType[] = ['supervisor', 'manager', 'controller', 'operator'];
type FormType = { qm_role: QmUsersRolesListType; qm_operator_id: string };

type QmUsersFormPropsType = {
  userData?: QmUserWithRoleType;
  onClose?: () => void;
};

const QmUsersForm: FC<QmUsersFormPropsType> = (props) => {
  const { userData, onClose } = props;
  const { t } = useTranslation('pages.usersPage.qm');

  // api
  // eslint-disable-next-line
  const [setQmUserRole] = useSetQmUserRoleMutation();
  // api

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm<FormType>({
    defaultValues: { qm_role: userData?.qm.role, qm_operator_id: userData?.qm?.operator_id },
  });

  const selectOptions: OptionItem[] = rolesList.map((role) => ({
    title: t(`roles.${role}`),
    value: role,
  }));

  function handleChangeOption(value: QmUsersRolesListType) {
    setValue('qm_role', value);
  }

  function onSubmit(values: FormType) {
    if (!userData?.id) return;
    const body = {
      qm_role: values.qm_role,
      qm_operator_id: values.qm_role === 'operator' ? values.qm_operator_id : undefined,
    };
    setQmUserRole({ params: { id: userData.id }, body })
      .unwrap()
      .finally(() => onClose?.());
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={formBaseContainerStyles}>
      <div className={formFieldBaseStylesModal650}>
        <span className={formFieldNameBaseStyles}>{t('form.name')}</span>
        <span className={formFieldNameBaseStyles}>{userData?.username}</span>
      </div>
      <div className={formFieldBaseStylesModal650}>
        <span className={formFieldNameBaseStyles}>{t('form.role')}</span>
        <Select
          dropHeight={90}
          defaultValue={watch('qm_role')}
          options={selectOptions}
          onChange={(value) => handleChangeOption(value as QmUsersRolesListType)}
        />
      </div>
      {watch('qm_role') === 'operator' && (
        <div className={formFieldBaseStylesModal650}>
          <span className={formFieldNameBaseStyles}>{t('form.operator_id')}</span>
          <Input
            {...register('qm_operator_id', {
              validate: (val) => (watch('qm_role') === 'operator' ? !!val || ' ' : true),
            })}
            error={errors.qm_operator_id?.message}
            maxLength={128}
          />
        </div>
      )}
      <div className={formBaseButtonBlockStyles}>
        <Button type="submit" label={t('form.approve_button')} />
        <Button fill="linked" onClick={onClose} label={t('form.cancel_button')} />
      </div>
    </form>
  );
};

export default QmUsersForm;
